import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { useGetPageDeal } from '@hooks/useGetPageDeal';
import LoadingSkeletons from '@pages/Pages/components/LoadingSkeletons';
import RelatedDeals from '@pages/Blog/components/RelatedDeals';

const ShowPageDeals = ({ slug }: { slug: string }) => {
  const { data: pageDeal, isFetching } = useGetPageDeal(slug);
  if (isFetching) {
    return (
      <Grid item xs={12}>
        <LoadingSkeletons amount={1} />
      </Grid>
    );
  }

  if (!pageDeal || pageDeal?.deals?.length === 0) {
    return (
      <Grid item xs={12}>
        <Box>
          <Typography variant="body1">Not Found</Typography>
        </Box>
      </Grid>
    );
  }

  return (
    <Grid
      item
      xs={12}
      sx={{
        marginBottom: '24px',
        marginTop: '8px'
      }}
    >
      <RelatedDeals
        previewDeals={6}
        relatedDeals={pageDeal?.deals || []}
        link={`/p/${slug}`}
        hideDealString
        tag={pageDeal.pageDeal?.tag || undefined}
      />
    </Grid>
  );
};

export default ShowPageDeals;
